export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00396.c0004e29.png";